/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import navigationActions from 'redux/actions/navigation';
import userSelectors from 'redux/reduxStore/user';
import listLocaleSelector from 'redux/reduxStore/lists/listLocale';

import CheckYourInbox from 'components/pages/other/CheckYourInbox';
import GroupSetupView from './GroupSetup.view';
import routeNames from 'lib/routeNames';
import AppUtils from 'lib/AppUtils';

function mapStateToProps(state) {
  const localeId = userSelectors.getLocaleId(state);
  return {
    localeId,
    defaultLanguage: listLocaleSelector.getLocale(state, localeId).language_code,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goBack: () => {
      dispatch(navigationActions.goTo(routeNames.loginPassword()));
    },
  }
}

class GroupSetupPresenter extends React.Component {

  constructor(props) {
    super(props);

    this.handleOnSubmitForm = this.handleOnSubmitForm.bind(this);
    this.handleOnChangeName = this.handleOnChangeName.bind(this);
    this.isOrganizationNameValid = this.isOrganizationNameValid.bind(this);
    this.isNameValid = this.isNameValid.bind(this);
    this.isUrlValid = this.isUrlValid.bind(this);
    this.isEmailValid = this.isEmailValid.bind(this);

    this.state = {
      email: '',
      subdomain: '',
      organization_name: '',
      name: '',
      syncNameAndSubdomainChanges: false,
    };
  }

  isOrganizationNameValid() {
    return this.state.organization_name.length > 0
  }

  isNameValid() {
    return this.state.name.length > 0
  }

  isUrlValid() {
    return this.state.subdomain.length > 0
  }

  isEmailValid() {
    return this.state.email.length > 0
  }

  handleOnSubmitForm() {
    const { email, subdomain, name, organization_name } = this.state;
    const { defaultLanguage } = this.props;
    const isDataValid = this.isOrganizationNameValid() && this.isEmailValid() && this.isUrlValid() && this.isNameValid();
    if (!isDataValid) { return; }

    this.props.createGroup({
      email,
      subdomain,
      name: {
        default: null,
        i18n: {
          [defaultLanguage]: name,
        },
      },
      organization_name: {
        default: null,
        i18n: {
          [defaultLanguage]: organization_name,
        }
      },
      locale_id: this.props.localeId,
    });
  }

  handleOnChangeName(name) {
    let subdomain = this.state.subdomain;

    if (this.state.syncNameAndSubdomainChanges) {
      subdomain = AppUtils.formatSubdomain(name);
    }

    this.setState({
      name,
      subdomain,
    });
  }

  render() {

    if (this.props.groupCreatedSuccessful) {
      return (
        <CheckYourInbox
          email=""
          goBack={this.props.resetGroupCreate}
          titlePhrase={{ id: 'groupSetupCheckInbox.title.text' }}
          notificationPhrase={{
            id: 'groupSetupCheckInbox.checkInbox.message.text',
            values: {
              string1: this.state.name,
              string2: this.state.subdomain + this.props.intl.formatMessage({ id: 'groups.baseURL.name.text' }),
              string3: this.state.email,
            },
          }}
          organizationName={ <FormattedMessage id="groupsetup.backpack.name" /> }
        />
      );
    }

    const isDataValid = this.isOrganizationNameValid() && this.isEmailValid() && this.isUrlValid() && this.isNameValid();

    return (
      <GroupSetupView
        organizationName={this.state.organization_name}
        name={this.state.name}
        email={this.state.email}
        subdomain={this.state.subdomain}
        onSubmitForm={this.handleOnSubmitForm}
        onChangeName={this.handleOnChangeName}
        onChangeOrganizationName={(organizationName) => { this.setState({ organization_name: organizationName }) }}
        onChangeUrl={(subdomain) => { this.setState({ subdomain: AppUtils.formatSubdomain(subdomain) }); }}
        onChangeEmail={(email) => { this.setState({ email }); }}
        hasInitialData={!!this.state.name}
        onStartChangeName={() => { this.setState({ syncNameAndSubdomainChanges: this.state.subdomain.length === 0 }); }}
        onFinishChangeName={() => { this.setState({ syncNameAndSubdomainChanges: false }); }}
        isSubmitDisabled={!isDataValid}
      />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(GroupSetupPresenter));